import { useEffect, useContext, useCallback } from 'react'
import { MapContext } from './Map';
import { AmostraValidaByTipoAmostra } from '../config/api';
import LayerRegistry from '../data/LayerRegistry';
import { serieAmostraColorsForMap } from '../data/UtilCoresLimiares';

const KEY_LAYERS = 'key_layers'

export default (props) => {
    const map = useContext(MapContext)

    useEffect(() => {
        if (!map) return
        if (!props.parametroSerie) return

        (async () => {
            const amostrasLayer = LayerRegistry.amostras.olLayer
            const features = await AmostraValidaByTipoAmostra(props.parametroSerie.serie.serie)
            if (!features || features.length === 0) return

            const source = amostrasLayer.getSource()
            source.clear()
            source.addFeatures(
                source.getFormat().readFeatures(
                    setStyleFeatureForSerie(features, props.parametroSerie.serie.serie)
                )
            );
        })()

    }, [map, props.parametroSerie])

    const setStyleFeatureForSerie = (features, serie) => {
        const cor = serieAmostraColorsForMap.get(serie)
        features.features.forEach(feature => { feature.properties.cor = cor })
        return features
    }

    const removeLayers = useCallback(() => {
        const vectorLayers = map.getLayers().getArray().filter(l => l.type === 'VECTOR')
        // const vlToRemove = vectorLayers.filter(vl => vl.getKeys().filter(vlk => vlk===KEY_LAYERS).length>0)
        // console.log(vectorLayers, vlToRemove)
        vectorLayers.forEach(vlr => map.removeLayer(vlr))
    }, [map])

    const addLayers = useCallback(() => {
        props.layers.length > 0 && props.layers.forEach(l => {
            if (!l.ocultarCamada) //não sinaliza a camada de analise
                l.layer.olLayer.set(KEY_LAYERS, true, false)

            map.addLayer(l.layer.olLayer)
        })
    }, [map, props.layers])

    useEffect(() => {
        if (!map) return
        if (!props.layers || props.layers.length === 0) return
        removeLayers();
        addLayers();
    }, [addLayers, map, props.layers, removeLayers])

    return null
}